let USER = {
  firstName: '',
  lastName: '',
  email: '',
  title : '',
  phone: '',
  userId: '',
  currentPassword : '',
  newPassword :''
};

export
default USER;


// WEBPACK FOOTER //
// ./app/models/user.js